import {Outlet, Navigate} from 'react-router-dom';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { GlobalContext } from '../../ui/context/global/GlobalContext';
import { Box, CircularProgress } from '@mui/material';

export const ProtectedRoute = ({redirect='/login'}) => {
  const {userState:{user}, authLoading} = useContext(GlobalContext);
  
  // Mostrar loader mientras verifica autenticación
  if (authLoading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  
  // Una vez verificado, redirigir o mostrar contenido
  return user ? <Outlet/> : <Navigate to={redirect}/>;
}

ProtectedRoute.propTypes = {
  redirect: PropTypes.string
}
